module.exports = __webpack_public_path__ + "media/images/front/environment/environment_1-1f8a7bc337d9f6caea410e0c810f4bcf.jpg";